import React from 'react';
import {
  MDBFooter,
  MDBContainer,
  MDBCol,
  MDBRow,
  MDBIcon,
  MDBBtn
} from 'mdb-react-ui-kit';
import './Footer.css';

export default function App() {
  return (
    <div className='sid'>
   

      <div className='ts'>
        Copyright: Siddhesh_Patil
       
      </div>

    </div>
  );
}